import { Scoring as ScoringComponent } from '@sravni/creditselection-react/lib/Scoring';
import { Space } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useSelector } from 'react-redux';

import { userScoreSelector } from '../../model/userScore.selectors';

export const Scoring = () => {
  const { score, description } = useSelector(userScoreSelector);
  return (
    <Space
      size={16}
      align="center"
    >
      <ScoringComponent scoreValue={score} />
      <Text
        size={16}
        strong
      >
        {description}
      </Text>
    </Space>
  );
};
